import { IonContent, IonHeader, IonRefresher, IonRefresherContent, IonPage, IonAlert, IonItem, useIonViewWillEnter } from '@ionic/react';
import React, { useState, useEffect, useContext, useCallback } from 'react';
import ListItems from '../components/ListItems';
import InnerMenu from '../components/InnerMenu';
import GpsSinglePointComponent from '../components/GpsSinglePointComponent';
import PageEventHandler from "../components/PageEventHandler"
import './Docks.css';
import NavigationWarningsService from '../services/NavigationWarningsService';
import { LanguageContext } from '../contexts/LanguageContext';
import { navigationWarningsTranslations } from '../translations/navigationWarnings';

const navigationWarningsService = new NavigationWarningsService();

const NavigationWarnings: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = navigationWarningsTranslations[language];

  const [showAlert2, setShowAlert2] = useState(false);
  const [warningsList, setWarningsList] = useState<any[] | null>(null);
  const [loadingText, setLoadingText] = useState(t.loading);
  const [userCoords, setUserCoords] = useState<any|null>(null);

  const loadList = useCallback(async () => {
    setLoadingText(t.loading);
    try {
      const warnings = await navigationWarningsService.refreshWarningsFromServer();
      if (warnings != null && Array.isArray(warnings)) {
        setWarningsList(warnings as any[]);
      } else {
        setWarningsList(null);
        setLoadingText(t.noWarningsMemory);
        setShowAlert2(true);
      }
    } catch {
      setWarningsList(null);
      setLoadingText(t.warningsError);
      setShowAlert2(true);
    }
  }, [t]);

  useIonViewWillEnter(() => {
    void loadList();
  }, [loadList]);

  useEffect(() => {
    setLoadingText(t.loading);
  }, [language, t.loading]);

  return (
    <IonPage>
      <IonHeader>
        <InnerMenu name={t.pageTitle} />
      </IonHeader>
      <IonContent fullscreen>
        <IonRefresher
          slot="fixed"
          onIonRefresh={async (ev) => {
            await loadList();
            ev.detail.complete();
          }}
        >
          <IonRefresherContent pullingText={t.pullToRefresh} refreshingSpinner="crescent" />
        </IonRefresher>
        <IonItem lines="none">
          <h1 className="mainTit" slot="start">{t.pageTitle}</h1>
          {/* commented for now as redundant
          <IonButton slot="end" routerLink="/docksMap" fill="clear" size="large">
            <IonIcon icon={mapOutline}></IonIcon>
          </IonButton>
          */}
        </IonItem>
        {/* while loading */}
        {warningsList == null &&
          <div>{loadingText}</div>
        }
        {/* if loading went fine */}
        {warningsList != null && warningsList.length > 0 && (
          <ListItems name={navigationWarningsTranslations.it.pageTitle} elements={warningsList} />
        )}
        {warningsList != null && warningsList.length === 0 && (
          <IonItem lines="none"><p>{t.noItems}</p></IonItem>
        )}
      </IonContent>
      <IonAlert
        header={t.errorHeader}
        isOpen={showAlert2}
        message={t.errorMessage}
        buttons={[{ text: t.okButton }]}
        onDidDismiss={() => setShowAlert2(false)}
      />
      <GpsSinglePointComponent setUserCoords={setUserCoords}/>
      <PageEventHandler pageIndex={15} dockIndex={0}/>
    </IonPage>
  );
};

export default NavigationWarnings;
